export function normalizeAccount(account) {
  if (account!=="0" && account!=="null" && account!==null && account!==0) {
    return account;
  }

  const storedAccounts = JSON.parse(
    localStorage.getItem("accountOptions") || "[]"
  );

  return storedAccounts
    .map(a => a.value)
    .filter(v => v !== "0" && v !== 0);
}
